<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro colectivo de salud</h1>
                <p>Ofrecerle a sus empleados la oportunidad de acceder a un seguro de salud complementario al Plan
                Obligatorio, es un beneficio más que puede incluir en su empresa, al darles la posibilidad de contar con
                servicios de alta calidad a un mejor precio.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Con el seguro Colectivo de salud tus empleados pueden:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="colectivo">
            <center>
                <p>Con un seguro de salud colectivo, sus empleados pueden estar tranquilos porque disfrutan de atenciones exclusivas en salud, como consultar
                directamente a un médico especialista sin necesidad de esperar una autorización por parte del médico general, gracias al amplio directorio
                médico en el que puede escoger al profesional de su preferencia y la institución en la que quiere ser atendido él o su grupo familiar.
                Contar con un plan colectivo de salud garantiza el pago de una tarifa estable a lo largo de la vida laboral de sus empleados sin altos
                incrementos en el valor de la prima.</p>
                <div>
                    <div class="img">
                        <img src="@/assets/Empresariales-Seguro-Colectivo/4.png" alt="">
                    </div>
                    <div class="informacion">
                        <h1>Descubre cuál es la opción perfecta para ti</h1>
                        <p>Conoce los beneficios que tiene el obtener un Seguro de Salud y consulta por el plan que se ajusta a tus necesidades.</p>
                        <button>Iniciar hoy mismo </button>
                    </div>
                </div>
            </center>
        </div>
        <div class="plan">
            <center>
                <div v-for="(plan, i) in planes" :key="i">
                    <img :src="plan.img" alt="">
                    <div>
                        <h1>{{plan.title}}</h1>
                        <p v-html="plan.description"></p>
                    </div>
                </div>
            </center>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresa se puede asegurar?</h1>
            <p>Cualquier empresa en la que se aseguren más de 10 empleados o más de 15 personas entre empleados y sus familias. Asimismo, cooperativas
            y fondos de empleados cuyos socios pertenezcan a la misma empresa.</p>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Seguro-Colectivo-salud',
    metaInfo() {
        return {
            title: 'Seguro colectivo de salud',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Ofrecerle a sus empleados la oportunidad de acceder a un seguro de salud complementario al Plan Obligatorio, es un beneficio más que puede incluir en su empresa, al darles la posibilidad de contar con servicios de alta calidad a un mejor precio.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados
    },
    data() {
        return {
            planes: [
                {
                    img: require('@/assets/Empresariales-Seguro-Colectivo/5.png'),
                    title: 'Plan Salud Global',
                    description: 'Si sus empleados salen con frecuencia del país esta es la opción con mayor respaldo para ellos y su empresa ante la ocurrencia de un accidente o enfermedad durante el viaje. Con este Seguro podrán ser atendidos en el extranjero como producto de una urgencia o emergencia y programar el tratamiento de alguna enfermedad diagnosticada durante la vigencia del seguro. <br><br> Igualmente, a nivel nacional, cuenta con una amplia cobertura que incluye -entre muchos otros servicios- acceso exclusivo a las sedes propias Salud, controles prenatales, tratamiento para cáncer y Sida/VIH, hospitalizaciones psiquiátricas y unidad de cuidados intensivos.'
                },
                {
                    img: require('@/assets/Empresariales-Seguro-Colectivo/6.png'),
                    title: 'Plan Salud Clásico',
                    description: 'Proteger a sus empleados y su grupo familiar será más fácil con el Plan Salud Clásico, gracias que pone a disposición de sus asegurados un conjunto de coberturas que pueden disfrutar de manera ilimitada en todo el país. <br><br> Los motivos son muchos: el principal es poder contar con la protección de un seguro que brinde coberturas tanto a nivel hospitalario como ambulatorio, además de contar con una amplia red de especialistas de nuestro directorio médico, con la posibilidad de consultar otro que esté fuera de él y realizar el reembolso de acuerdo al valor que se contrate en el Plan.'
                },
                {
                    img: require('@/assets/Empresariales-Seguro-Colectivo/7.png'),
                    title: 'Plan Salud Evoluciona',
                    description: 'Con este nuevo plan, sus empleados podrán acceder a los servicios y coberturas de su póliza de forma ágil y simple. Cuenta con coberturas hospitalarias y ambulatorias y con una amplia red de prestadores de calidad. <br><br> Ofrecemos atención domiciliaria en urgencias y laboratorios, sumado a un concepto de gestión del riesgo en salud que busca el acompañamiento y la inclusión en el autocuidado de la salud.'
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Tener la posibilidad de escoger el profesional de su preferencia.',
                            img: require('@/assets/Empresariales-Seguro-Colectivo/1.png')
                        },
                        {
                            text: 'Extender la protección a su grupo familiar.',
                            img: require('@/assets/Empresariales-Seguro-Colectivo/2.png')
                        },
                        {
                            text: 'Pagar una tarifa estable a lo largo de la vida laboral.',
                            img: require('@/assets/Empresariales-Seguro-Colectivo/3.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 50px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service {
        width: 100%;
    }
    .services > center > div > div > .service > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 35px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .colectivo {
        background: -webkit-gradient(linear,left bottom, right top,color-stop(30%, #f7ebff), to(#cbe5fe));
        background: linear-gradient(to top right,#f7ebff 30%, #cbe5fe 100%);
    }
    .colectivo > center {
        padding: 50px 200px;
    }
    .colectivo > center > p {
        font-family: 'JR';
        text-align: left;
        font-size: 22px;
        line-height: 25px;
    }
    .colectivo > center > div {
        display: flex;
    }
    .colectivo > center > div > .informacion {
        padding-top: 120px;
        text-align: left;
        padding-left: 50px;
    }
    .colectivo > center > div > .informacion > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 20px;
    }
    .colectivo > center > div > .informacion > p {
        font-family: 'JR';
        font-size: 22px;
        line-height: 25px;
        margin-bottom: 20px;
    }
    .colectivo > center > div > .informacion > button {
        font-family: 'JR';
        background-color: #2d4f98;
        color: #fff;
        border-radius: 14px;
        padding: 7px 25px 7px 25px;
        border-style: none;
        font-weight: bolder;
        font-size: 18px;
        border-style: solid;
        border-color: #2d4f98;
    }
    .colectivo > center > div > .informacion > button:hover {
        background:#65b24a;
        color: #fff;
        border-color: #fff;
        border-style: solid;
    }
    .plan > center {
        padding: 50px 200px;
    }
    .plan > center > div{
        display: flex;
    }
    .plan > center > div > div {
        padding-top: 30px;
        text-align: left;
    }
    .plan > center > div > img {
        width: auto;
        height: auto;
    }
    .plan > center > div > div > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .plan > center > div > div > p {
        font-family: 'JR';
        font-size: 18px;
        line-height: 25px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }

    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .colectivo > center {
            padding: 50px 100px;
        }
        .plan > center {
            padding: 50px 100px;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .colectivo > center {
            padding: 50px 50px;
        }
        .plan > center {
            padding: 50px 50px;
        }
    }
    @media (max-width: 1200px) {
        .plan > center > div {
            display: block;
        }
        .plan > center > div > img {
            width: 70%;
            height: auto;
        }
    }
    @media (max-width: 1100px) {
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .services {
            padding: 0px 50px;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
    }
    @media (max-width: 700px) {
        .colectivo > center > div > .informacion {
            padding-left: 0px;
            padding-top: 50px;
        }
        .colectivo > center > div > .informacion > h1 {
            font-size: 30px;
        }
        .plan > center > div > div > h1 {
            font-size: 30px;
        }
        .plan > center > div > div > p {
            font-size: 18px;
        }
        .plan > center > div > img {
            width: 95%;
            height: auto;
        }
    }
    @media (max-width: 600px) {
        .colectivo > center > div {
            display: block;
        }
        .colectivo > center > div > .img > img {
            width: 100%;
        }
        .colectivo > center > p {
            font-size: 18px;
        }
        .colectivo > center > div > .informacion > h1 {
            font-size: 25px;
        }
        .colectivo > center > div > .informacion > p {
            font-size: 18px;
        }
        .plan > center > div > div > h1 {
            font-size: 25px;
        }
        .plan > center > div > div > p {
            font-size: 18px;
        }
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
    }
    @media (max-width: 500px) {
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/SeguroColectivoSalud.vue